export default __webpack_public_path__ + "static/4-d9ca7a98d86ad0fc9a36b5697d0c45f1.jpg";